import React, { ReactElement } from 'react';

import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import { CARD_PRIMARY } from '../../constants/colors';

interface CustomTooltipProps {
  tooltipTitle: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | string;
  placement?: 'bottom' | 'top';
  children: ReactElement<any, any>;
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: CARD_PRIMARY
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: CARD_PRIMARY,
    filter: 'drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.5))'
  }
}));

const CustomTooltip = ({ tooltipTitle, children, placement = 'bottom' }: CustomTooltipProps) => {
  return (
    <StyledTooltip title={tooltipTitle} placement={placement}>
      {children}
    </StyledTooltip>
  );
};

export default CustomTooltip;
